import React, { Component } from "react";
import Rating from "react-star-rating-component";
import styled from "styled-components";
// import { TiStarFullOutline } from "react-icons/ti";
import {isMobile} from "../../utils/util"

import "./OrderedProduct.css";

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

export default class OrderedProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addedToCart: false,
      productCart: props.productCart,
      productCartIds: props.productCartIds,
      rating: 0,
    };
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //     return ((this.props.productCart !== nextProps.productCart) ||
  //     		(this.props.productsArrKey !== nextProps.productsArrKey) ||
  //         (this.state.addedToCart !== nextState.addedToCart))
  // }
  // 第二步
  updateShopify = () => {
    this.props.syncProducts(this.props.product);
    // this.props.calculatePrice();
  };
  onStarClick(nextValue, prevValue, name) {
    this.setState({rating: nextValue});
  }
  // Determine if the item has been added to the shopping cart
  componentDidMount() {
    if(this.state.productCart.map(product => product.id).includes(this.props.product.id)){
      this.setState({ addedToCart: true})
    }else {
        this.setState({ addedToCart: false})
    }
  }

  componentWillReceiveProps(){
    if(this.state.productCart.map(product => product.id).includes(this.props.product.id)){
      this.setState({ addedToCart: true})
    }else {
        this.setState({ addedToCart: false})
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.productCart !== prevProps.productCart) {
        this.setState({ productCart: this.props.productCart }, () => {
            if ((this.state.productCart && this.state.productCart.some(product => product.id === this.props.product.id))) this.setState({ addedToCart: true });
            else this.setState({ addedToCart: false });
        });
    }
  }

  addToCartLabel(e) {
    e.stopPropagation();
    if(this.props.product.inventory <= 0){
      alert('Out of stock');
      return false
    }else{
      let addedToCart = !this.state.addedToCart;
      this.setState({ addedToCart: addedToCart }, () => {
        this.updateShopify();
      });
    }
  }

  render() {
    let AddToCart = styled.div`
      font-family: "Open Sans", Helvetica, Arial, sans-serif;
      font-size: 12.2px;
      font-weight: 600;
      color: #272d67;
      flex-basis: 43%;
    `;

    let Price = styled.div`
      font-family: "Open Sans", Helvetica, Arial, sans-serif;
      font-size: 11.2px;
      letter-spacing: 0.3px;
      text-align: left;
      color: #272d67;
      font-weight: normal;
      line-height: 1.71;
    `;

    let ProductInfo = styled.div`
      width: 100%;
      margin-bottom: 1em;
      text-align:left;
    `;

    //STYLES
    const brandTxtLg = {
      fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
      fontSize: "11.2px",
      fontWeight: "600",
      letterSpacing: "0.3px",
      color: "#272d67",
      lineHeight: "normal"
    };

    const txtLg = {
      fontFamily: "Montserrat",
      fontSize: "14px",
      letterSpacing: "0.3px",
      fontWeight: "600",
      color: "#272d67",
      lineHeight: "normal",
      height: "41px",
      overflow: 'hidden'
    };

    const product = this.props.product;
    let name = product.name.replace("®", "");
    return (
      <div className="ordered-product">
          <div className="row">
            <div className="image-column">
              <a target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href={`/recommendations/products/${this.props.product.id}`}>
                <img alt={product.name}  className="lazyload" data-src={product.coverImageSource} />
              </a>
            </div>
            {/*<div className="info-column">
              <div className="vendor">{ product.vendor }</div>
              <div className="name">{ product.name.includes(product.vendor) ? name.replace(product.vendor, '').trim() : name }</div>
            </div>*/}
            <ProductInfo>
              <div className="product-info">
                <Price className="price">${product.price}</Price>
                <div className="brand" style={brandTxtLg}>
                  {product.vendor}
                </div>
                <div className="product-name" style={txtLg}>
                  {product.name.includes(product.vendor)
                    ? name.replace(product.vendor, "").trim()
                    : name}
                </div>
              </div>
              <div className="product-info-bottom">
                <div className="product-info-quantity">Quantity: {product.quantity}</div>
                <AddToCart className="button-holder">
                  <button
                    className={
                      !this.state.addedToCart
                        ? "cart-button"
                        : "cart-button addedButton"
                    }
                    onClick={this.addToCartLabel.bind(this)}
                  >
                   
                    { !this.state.addedToCart ? "Add" : "Added" }
                    <i className="cart-icon"></i>
                  </button>
                </AddToCart>
              </div>
              
            </ProductInfo>
            {/*  这个地方需要重新设计，暂时把整个评分section 去掉  */}
            <div className="bottom-section" style={{display:'none'}}>
              <div className="rating-section">
                <div className="your-rating">Your Rating</div>
                <div className="rating-stars">
                  {product.rating !== null ? (
                    <Rating
                      name="product-rating"
                      starCount={5}
                      renderStarIcon={(index, value) => (
                        <span>
                          {/* <TiStarFullOutline size={12} /> */}
                          <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} style={{fontSize:'20px'}} />
                        </span>
                      )}
                      starColor="#ffad94"
                      emptyStarColor="#fff"
                      value={product.rating}
                    />
                  ) : (
                    <Rating
                      name="product-rating"
                      starCount={5}
                      renderStarIcon={(index, value) => (
                        <span>
                          {/* <TiStarFullOutline size={12} /> */}
                          <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} style={{fontSize:'20px'}} />
                        </span>
                      )}
                      starColor="#ffad94"
                      emptyStarColor="#c6ced9"
                      value={this.state.rating}
                      onStarClick={this.onStarClick.bind(this)}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="action-column">
              {/* <button onClick={ this.props.handleReorder }>Reorder</button>
              <button onClick={ this.props.handleReturn }>Return</button> */}
            </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/order/OrderedProduct.js